/**
 * `listBucket` on every clients/{id} doc lets portals query only the clients
 * they can show. Without it every portal downloaded the whole collection —
 * ~5,000 unreleased CSV-merge drafts included — and filtered in the browser.
 *
 *   live           → everything the adviser / paraplanner / calendar views use
 *                    (includes unreleased manual-AR clients; the portal toggle governs them)
 *   csvMergeDraft  → unreleased CSV-merge imports; only the CSV Merge portal reads these
 *   sandbox        → Guided Advice sandbox test clients (Oct 2026): anonymised copies loaded by
 *                    scripts/guided-sandbox.cjs, opened only from Settings → Guided Advice Sandbox
 *
 * Every write that creates a client, or changes importSource.kind /
 * csvMerge.releasedAt, must set the field via computeClientListBucket. A doc
 * without it is invisible to the portals until the server sweep
 * (server/lib/clientListBucketSweep.cjs) repairs it.
 *
 * CommonJS body so Node 18 can require() it and webpack can bundle it
 * (see src/utils/smsSendWindow.js). Keep it free of object rest/spread.
 */

const CLIENT_LIST_BUCKET_FIELD = 'listBucket';
const CLIENT_LIST_BUCKETS = Object.freeze({
  LIVE: 'live',
  CSV_MERGE_DRAFT: 'csvMergeDraft',
  SANDBOX: 'sandbox',
});

// Mirrors CSV_MERGE_SOURCE_KIND in src/constants/csvMerge.js (ESM, not requirable from Node).
const CSV_MERGE_SOURCE_KIND = 'ready-advice-csv-merge';

/** Same rule as isUnreleasedCsvMerge in src/constants/csvMerge.js. */
function computeClientListBucket(client) {
  if (client && client.isTestClient === true && client.sandbox && client.sandbox.alias) return CLIENT_LIST_BUCKETS.SANDBOX;
  const kind = client && client.importSource && client.importSource.kind;
  const releasedAt = client && client.csvMerge && client.csvMerge.releasedAt;
  return kind === CSV_MERGE_SOURCE_KIND && !releasedAt
    ? CLIENT_LIST_BUCKETS.CSV_MERGE_DRAFT
    : CLIENT_LIST_BUCKETS.LIVE;
}

module.exports = {
  CLIENT_LIST_BUCKET_FIELD,
  CLIENT_LIST_BUCKETS,
  CSV_MERGE_SOURCE_KIND,
  computeClientListBucket,
};
